import 'virtual:uno.css'
import '@/styles/design-tokens.css'
import { createApp } from 'vue'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import App from './App.vue'
import router from './router'
import { createAppPinia } from '@/stores'
import { initH5Entry } from '@/utils/h5-entry'

const pinia = createAppPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(Vue3Toastify, {
  autoClose: 2000,
  position: 'top-center',
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  theme: 'dark',
})
initH5Entry(pinia)
app.mount('#app')
